import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "platform-admin-menu" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Painel interno", -1)
const _hoisted_4 = { class: "links" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref } from 'vue'
import { useAxios } from '@/api/axios'
import router from '@/router'
import { platformAdmin } from '@/global/states/PlatformAdminState'
import Loader from '@/components/loader/Loader.vue'
import fluxooLogo from '@/assets/images/fluxoo-doc-logo.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformAdminLayoutMenu',
  setup(__props) {

const axios = useAxios()
const isLoggingOut = ref(false)

const logout = () => {
  isLoggingOut.value = true

  axios.post('/api/platform-admin/logout').then(() => {
    router.push({ name: 'platform-admin.login' })
  }).finally(() => isLoggingOut.value = false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", {
        class: "brand",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.dashboard' })))
      }, [
        _createElementVNode("img", {
          src: _unref(fluxooLogo),
          alt: "Logo fluxoo doc"
        }, null, 8, _hoisted_2),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass({ active: _ctx.$route.name === 'platform-admin.dashboard' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.dashboard' })))
        }, "Dashboard", 2),
        _createElementVNode("button", {
          class: _normalizeClass({ active: _ctx.$route.name === 'platform-admin.tenants.index' || _ctx.$route.name === 'platform-admin.tenants.edit' }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.index' })))
        }, "Tenants", 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(platformAdmin).name), 1),
        _createElementVNode("button", {
          title: "Desconectar",
          onClick: logout
        }, _hoisted_7)
      ])
    ]),
    (isLoggingOut.value)
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          zIndex: 10
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})